<template>
  <div class="p-chat-status-banner">
    <p-icon v-if="icon" :icon="icon" size="sm" :color="iconColor" />
    <span class="p-chat-status-banner__text">{{ text }}</span>
  </div>
</template>

<script lang="ts" setup>
defineProps<{
  text: string
  icon?: string
  iconColor?: string
}>()
</script>

<style lang="scss" scoped>
.p-chat-status-banner {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 4px 24px; // Figma node 5192:16618: py-xsmall(4px) px-xlarge(24px)

  &__text {
    font-size: 16px;
    line-height: 22px; // Body/Body 16 per Figma
    color: var(--fg-primary);
    text-align: center;
  }
}
</style>
